<script setup lang="ts">
import { useModel } from './../model/model'
import ObjectSearchList from './ObjectSearchList.vue'
import type { ObjectSearchType } from './../model/types'
import { useRouter } from 'vue-router'
import { ObjectTypes } from '@/entities/Object'

const router = useRouter()
const { search, list, isLoading, clearHandler, reloadData } = useModel()

/**
 * Обрабатываем выбор элемента списка
 * @param item
 */
const selectHandler = (item: ObjectSearchType) => {
  search.value = ''
  list.value = []

  router.push(`/objects/${ObjectTypes[item.object_type_id].alias}/${item.id}/monitoring`)
}

/**
 * Обрабатываем открытие элемента по клику с ctrl/meta
 * @param item
 */
const openSelectHandler = (item: ObjectSearchType) => {
  const route = router.resolve(
    `/objects/${ObjectTypes[item.object_type_id].alias}/${item.id}/monitoring`,
  )
  window.open(route.href, '_blank')
}
</script>

<template>
  <div class="object-search mb-2" v-click-outside="clearHandler">
    <VTextField
      color="white"
      v-model="search"
      @input="reloadData"
      :label="$t('itf.search')"
      :loading="isLoading"
      :placeholder="$t('itf.search_label', { num: 3 })"
      :hide-details="true"
    />

    <ObjectSearchList :list="list" @selected="selectHandler" @open_select="openSelectHandler" />
  </div>
</template>
